import React, { lazy, Suspense } from 'react'
import { MapPin, Phone, Mail, Clock } from 'lucide-react'
import ContactForm from './inner_components/ContactFrom'
const Hero = lazy(() => import('./inner_components/Hero'))

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Suspense
        fallback={<div className="h-[35rem] bg-gray-200 animate-pulse" />}
      >
        {/* Hero Section */}
        <div data-aos="fade-down" data-aos-duration="400">
          <Hero
            tagline="Contact Us"
            title="Get In Touch"
            description="We're here to help with your transportation needs."
            bgImage="/images/contact.jpg"
          />
        </div>
      </Suspense>

      {/* Contact Information Cards */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div
          className="text-center mb-16"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <h1 className="text-4xl font-bold text-gray-900">
            Ready to Experience the Difference?
          </h1>
          <p className="mt-4 text-xl text-gray-600">
            Partner with RoyalRise for all your corporate transportation needs
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 mb-16">
          {/* Address Card */}
          <div
            className="bg-white p-6 rounded-lg shadow-md text-center"
            data-aos="zoom-in"
            data-aos-duration="400"
            data-aos-delay="0"
          >
            <div className="flex justify-center mb-4">
              <MapPin className="h-10 w-10 text-[#1865a5]" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Address:</h3>
            <p className="text-gray-600">
              No.20, 2ND CROSS, ROYAL MERIDIEN LAYOUT, DEVARCHIKKANAHALLI, BEGUR
              ROAD, Bangalore - 560076 Karnataka
            </p>
          </div>

          {/* Phone Card */}
          <div
            className="bg-white p-6 rounded-lg shadow-md text-center"
            data-aos="zoom-in"
            data-aos-duration="400"
            data-aos-delay="50"
          >
            <div className="flex justify-center mb-4">
              <Phone className="h-10 w-10 text-[#1865a5]" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Phone:</h3>
            <p className="text-gray-600">+91 8884903332</p>
            <p className="text-gray-600">+91 8884903331</p>
          </div>

          {/* Email Card */}
          <div
            className="bg-white p-6 rounded-lg shadow-md text-center"
            data-aos="zoom-in"
            data-aos-duration="400"
            data-aos-delay="100"
          >
            <div className="flex justify-center mb-4">
              <Mail className="h-10 w-10 text-[#1865a5]" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Email:</h3>
            <p className="text-gray-600">info@royalrisetours.com</p>
          </div>

          {/* Working Hours Card */}
          <div
            className="bg-white p-6 rounded-lg shadow-md text-center"
            data-aos="zoom-in"
            data-aos-duration="400"
            data-aos-delay="150"
          >
            <div className="flex justify-center mb-4">
              <Clock className="h-10 w-10 text-[#1865a5]" />
            </div>
            <h3 className="text-lg font-semibold mb-2">Working Hours:</h3>
            <p className="text-gray-600">24/7</p>
          </div>
        </div>

        <div
          className="text-center mb-12"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <h2 className="text-3xl font-bold text-gray-900">
            If you got any questions
          </h2>
          <p className="mt-2 text-xl text-gray-600">
            please do not hesitate to send us a message
          </p>
        </div>

        {/* Contact Form */}
        <ContactForm />

        {/* Google Maps Integration */}
        <div
          className="mt-16 h-96 rounded-lg overflow-hidden shadow-md"
          data-aos="fade-up"
          data-aos-duration="500"
          data-aos-delay="100"
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d248849.84916296526!2d77.6309395!3d12.9539974!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7008bf250264b51%3A0x4fb2602409cd7c5!2sRoyalRise%20Tours%20and%20Travels%20Private%20Limited!5e0!3m2!1sen!2sin!4v1738778836604!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Maps Location for Our Office"
          />
        </div>
      </div>
    </div>
  )
}

export default ContactPage
